import React, { useState, useRef } from 'react';
import { spacing, borderRadius, shadows } from '../../constants/designTokens';
import { useTheme } from '../../contexts/ThemeContext';

const SimpleTooltip = ({ children, content }) => {
  const { colors } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  
  const showTooltip = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 8,
        left: rect.left + rect.width / 2
      });
      setIsVisible(true);
    }
  };
  
  const hideTooltip = () => {
    setIsVisible(false);
  };
  
  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        style={{ display: 'inline-flex' }}
      >
        {children}
      </div>
      {isVisible && (
        <div style={{
          position: 'fixed',
          top: `${position.top}px`,
          left: `${position.left}px`,
          transform: 'translate(-50%, -100%)',
          background: colors.foreground,
          color: colors.background,
          padding: `4px ${spacing.lg}`,
          borderRadius: borderRadius.sm,
          fontSize: '0.75rem',
          maxWidth: '320px',
          lineHeight: '1.2',
          zIndex: 9999,
          pointerEvents: 'none',
          boxShadow: shadows.md,
          animation: 'tooltipFadeIn 0.15s ease-out',
          whiteSpace: 'normal',
          wordWrap: 'break-word'
        }}>
          <style>{`
            @keyframes tooltipFadeIn {
              from { opacity: 0; transform: translate(-50%, calc(-100% + 4px)); }
              to { opacity: 1; transform: translate(-50%, -100%); }
            }
          `}</style>
          {content}
          <div style={{
            position: 'absolute',
            bottom: '-4px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: `4px solid ${colors.foreground}`
          }} />
        </div>
      )}
    </>
  );
};

export default SimpleTooltip;